"use client";
import "@/styles/home/expandingcard.css";
import { useState } from "react";
import { m } from "framer-motion";
import Image from "next/image";
import { twMerge } from "tailwind-merge";
import { useIsDark } from "@/context/ThemeContext";

export default function ExpandingCard({ title, description, icon }) {
  const [isHovered, setIsHovered] = useState(false);
  const isdark = useIsDark();

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={twMerge(
        "relative w-full aspect-292/449 rounded-xl overflow-hidden text-white border transition-all duration-300",
        isHovered ? "border-[#FF1CF7]" : "border-transparent",
        isdark ? "bg-[#FFFFFF0D]" : "bg-[#FFFFFF]"
      )}
      style={{ boxShadow: "4px 4px 10px 0px #0000001A" }}
    >
      <m.div
        initial={false}
        animate={{ opacity: isHovered ? 0 : 1 }}
        transition={{ duration: 0.4 }}
        className="absolute top-0 left-0 w-full z-10 h-1/2"
      >
        <div>
          {/* semi transparent overlay */}
          <div
            className={twMerge(
              "absolute inset-0 w-full z-20",
              isdark ? "bg-[#00000066]" : "bg-[#0000004D]"
            )}
          />
          <Image
            src={icon}
            alt={title}
            fill
            className="object-cover"
            sizes="(max-width: 640px) 90vw,
                   (max-width: 768px) 80vw,
                   (max-width: 1024px) 45vw,
                   (max-width: 1280px) 30vw,
                   350px"
            quality={85}
            placeholder={typeof icon === "string" ? undefined : "blur"}
          />
        </div>
      </m.div>

      <m.div
        initial={false}
        animate={{ y: isHovered ? 0 : "51%" }}
        transition={{ type: "spring", mass: 1, stiffness: 100, damping: 15 }}
        className="absolute z-20 h-full flex flex-col px-2 py-3 mobile:px-2.5 md:px-2 tablet:px-3"
      >
        <div>
          <h1
            className={twMerge(
              "bg-clip-text text-transparent bg-linear-to-r font-semibold font-manrope text-[16px] mobile:text-[18px] md:text-[15px] tablet:text-[16px] lg:text-xl laptop:text-2xl 3xl:text-[26px] 4xl:text-[28px]",
              isdark
                ? "from-[#FF1CF7] to-[#EEEEFF]"
                : "from-[#9C00BB] to-[#1A1A1A]"
            )}
          >
            {title}
          </h1>
          <div
            className={twMerge(
              "h-px w-1/2 mt-2 sm:mt-3 xl:mt-[18px]",
              isdark ? "bg-[#FF1CF7]" : "bg-[#5A5A6E]"
            )}
          ></div>
          <p
            className={twMerge(
              "font-medium font-manrope text-[12px] small:text-[13px] mobile:text-[14px] md:text-[12px] tablet:text-[16px] laptop:text-[18px] 4xl:text-[22px] leading-relaxed mt-1.5 sm:mt-3 xl:mt-[18px]",
              !isHovered && "line-clamp-3",
              isdark ? "text-[#FF1CF7]" : "text-[#5A5A6E]",
              isdark && isHovered && "text-[#FFFFFF]"
            )}
          >
            {description}
          </p>
        </div>
        <div
          className={`text-right text-[18px] text-paragraph ${
            isHovered ? " opacity-0" : ""
          } `}
        >
          →
        </div>
      </m.div>
    </div>
  );
}
